import React, { CSSProperties, useEffect, useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const canUseDOM = typeof window !== 'undefined';
const useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;

interface IProps {
    fontStyle: CSSProperties;
    bgColor: string;
    bgHeight?: number;
    text: string | React.ReactNode;
    className?: string;
}

function TextHighlighter({ fontStyle, bgColor, bgHeight = 8, text, className }: IProps) {
    const textRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState(0);

    useIsomorphicLayoutEffect(() => {
        if (textRef.current !== null) setWidth(textRef.current.offsetWidth);
    }, [text]);

    return (
        <Container className={className}>
            <Text ref={textRef} fontStyle={fontStyle}>
                {text}
            </Text>
            <Background background={bgColor} width={width} height={bgHeight} />
        </Container>
    );
}

const Container = styled.div`
    ${({ theme }) => theme.flex.flexColumn};
    ${({ theme }) => theme.flex.justifyCenter};
`;

const Text = styled.div<{ fontStyle: CSSProperties }>`
    z-index: 1;
    ${({ fontStyle }) => ({ ...fontStyle })}
`;

const Background = styled.div<{ background: string; width: number; height: number }>`
    position: absolute;
    background-color: ${({ background }) => background};
    width: ${({ width }) => width + 6}px;
    height: ${({ height }) => height}px;
    margin-top: ${({ height }) => height}px;
`;

export default TextHighlighter;
